import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { IConfiguredMenuItem } from './menu.models';

@Component({
    selector: 'app-menu-section',
    templateUrl: './menu-section.component.html',
    styleUrls: ['./menu-section.component.scss']
})
export class MenuSectionComponent {
    @Input() title: string;
    @Input() icon: string;
    @Input() svgIcon: string | null = null;
    @Input() titleId: string;
    @Input() sectionKey: string;
    @Input() visible: boolean = true;
    @Input() expanded: boolean = false;
    @Input() items: IConfiguredMenuItem[] = [];
    @Input() selectedItemId: string | null = null;

    @Output() sectionClick = new EventEmitter<string>();
    @Output() menuItemClick = new EventEmitter<IConfiguredMenuItem>();
    @Output() menuExternalClick = new EventEmitter<MouseEvent>();

    @ViewChild(MatExpansionPanel)
    panel: MatExpansionPanel;

    open(): void {
        this.panel?.open();
    }

    onHeaderClick(): void {
        this.sectionClick.emit(this.sectionKey);
    }

    trackByMenuItemId(_index: number, item: IConfiguredMenuItem): string {
        return item.id;
    }
}
